import styled from "styled-components";
import { colors } from "@pepdirect/v3/styles/variables";
import { Device } from "@pepdirect/v3/styles/screenSizes";

export const StyledChecked = styled.div`
  height: 24px;
  width: 24px;
  margin-right: 12px;
`;

export const StyledCheckedIcon = styled.div`
  position: absolute;
`;

export const StyledContentContainer = styled.div`
  width: 100%;
`;

export const StyledDefault = styled.div<{
  isDisabled?: boolean;
}>`
  color: ${colors.gray500};
  font-style: italic;

  ${({ isDisabled, theme }) =>
    isDisabled &&
    `
      color: ${theme.color.disabled};
  `}
`;

export const StyledAddress = styled.div`
  color: ${colors.gray500};
`;

export const StyledOption = styled.div<{
  checked: boolean;
  isDisabled?: boolean;
}>`
  align-items: center;
  border-radius: 6px;
  border: 1px solid ${colors.gray200};
  cursor: pointer;
  display: flex;
  font-size: 13px;
  padding: 20px 16px;

  @media ${Device.mobile} {
    padding: 12px;
  }

  /*
    TODO: Change background color to theme.color.accent
    when theme is ready and remove opacity.
  */
  ${({ checked, theme }) =>
    checked &&
    `
      background-color: ${theme.color.primary}30;
      border-color: ${theme.color.primary};
      outline: 1px solid ${theme.color.primary};
  `}

  ${({ isDisabled, theme }) =>
    isDisabled &&
    `
      color: ${theme.color.disabled};
      cursor: not-allowed;
  `}
`;

export const StyledTitle = styled.div`
  font-weight: bold;
  font-size: 14px;
`;

export const StyledRightAlignedContent = styled.div<{ $marginLeft?: number }>`
  margin-left: ${({ $marginLeft }) =>
    $marginLeft ? `${$marginLeft}px` : "auto"};
  flex-shrink: 0;
`;

export const StyledImageWrapper = styled.div`
  margin-right: 12px;
`;
